import React, { useEffect, useRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { DialogContent, DialogTitle } from "@mui/material";
import cross from "../../../../assets/svg/cross.svg";
import copy from "../../../../assets/svg/copy.svg";
import copyGray from "../../../../assets/svg/copy--gray.svg";
import share from "../../../../assets/svg/share.svg";
import download from "../../../../assets/svg/download.svg";
import downloadGrey from "../../../../assets/svg/download--gray.svg";
import QRCodeStyling from "qr-code-styling";

import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import SwipeableViews from "react-swipeable-views";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

import styles from "./ShareDialog.module.scss";
import { useUser } from "../../../../providers/user.provider";
import { useGuest } from "../../../../providers/guest.provider";
import { useWindowDimensions } from "../../../../services/widthCheck.service";
import QRCode from "../../QRCode/QRCode";
import html2canvas from "html2canvas";

import domtoimage from "dom-to-image";

interface ITolDialog {
  open: boolean;
  onClose: () => void;
  onShare: (url: string) => void;
  [key: string]: any;
}

const ShareDialog = (props: ITolDialog) => {
  const { width } = useWindowDimensions();
  const { setActiveSnackBar, activeSnackBar } = useGuest();
  const user = useUser();
  const { open, onClose, onShare, ...other } = props;
  const [base64, setBase64] = useState<string[]>([]);
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState<boolean>(true);
  const qrCodeImageRef = useRef<any>(null);
  const qrCodeRef = useRef<any>(null);
  const [qrCodeData, setQrCodeData] = useState<any>(null);
  const [activeUrl, setActiveUrl] = useState("");

  const olinks = [
    {
      path: user.currentOLink?.path,
    },
  ];

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator?.userAgent);
  // user.currentOLink?.olinksNames!.map((on) => {
  //   olinks.push({
  //     path: user.currentOLink?.path + "?name=" + on.name,
  //   });
  // });

  const handleClose = () => {
    onClose && onClose();
  };

  const shareViaSocial = (type: string, url: string) => () => {
    // Open ShareSocialDialog with the exact URL selected (custom domain or standard)
    onShare && onShare(url);
  };

  const copyToClipboard = () => {
    copyImageToClipBoardSafari();

    // if (isSafari) {
    //   copyImageToClipBoardSafari();
    // } else {
    //   copyImageToClipBoardOtherBrowsers();
    // }
  };

  const snapshotCreator = (): any => {
    return new Promise((resolve, reject) => {
      try {
        if (childComponentRef.current) {
          // Use QRCodeStyling directly to get PNG blob — domtoimage cannot capture <canvas>
          const qrInfo = childComponentRef.current.getQRCodeInfo();
          qrInfo.data.data = qrInfo.url;
          qrInfo.data.width = 1024;
          qrInfo.data.height = 1024;
          const qrCode = new QRCodeStyling(qrInfo?.data);
          qrCode.getRawData("png").then((blob: any) => {
            resolve(blob);
          }).catch(reject);
        } else {
          reject(new Error("QR ref not available"));
        }
      } catch (e) {
        reject(e);
      }
    });
  };

  const copyImageToClipBoardSafari = () => {
    navigator.clipboard
      .write([
        new ClipboardItem({
          "image/png": new Promise(async (resolve, reject) => {
            try {
              const blob = await snapshotCreator();
              resolve(new Blob([blob], { type: "image/png" }));
            } catch (err) {
              reject(err);
            }
          }),
        }),
      ])
      .then(() => {
        setActiveSnackBar({
          state: true,
          name: "success",
          message: "QR Code copied",
        });
      })
      .catch((err) =>
        // Error
        console.error("Error:", err)
      );
  };

  const copyImageToClipBoardOtherBrowsers = async () => {
    const canvas = await html2canvas(qrCodeImageRef.current, {
      allowTaint: true,
      useCORS: true,
    });

    const dataURL = canvas.toDataURL("image/png");

    const makeImagePromise = async () => {
      const response = await fetch(dataURL);
      return await response.blob();
    };

    navigator.clipboard
      .write([new ClipboardItem({ "image/png": makeImagePromise() })])
      .then(function () {
        setActiveSnackBar({
          state: true,
          name: "success",
          message: "QR Code copied",
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const childComponentRef = useRef<any>(null);

  const handleDownload = () => {
    if (childComponentRef.current) {
      const qrInfo = childComponentRef.current.getQRCodeInfo();
      qrInfo.data.data = qrInfo.url;
      qrInfo.data.width = 1024;
      qrInfo.data.height = 1024;
      const qrCode = new QRCodeStyling(qrInfo?.data);

      console.log("QR Info:", qrInfo);
      qrCode.download({ name: "qr", extension: "svg" });
    }
  };
  // const handleDownload = async () => {
  //   const canvas = await html2canvas(qrCodeRef.current, {
  //     scale: 2,
  //     allowTaint: true,
  //     useCORS: true,
  //   });
  //   const dataURL = canvas.toDataURL("image/png");
  //   const blob = await new Promise((resolve, reject) => {
  //     const link = document.createElement("a");
  //     link.href = dataURL;
  //     link.download = "qrCode.png";
  //     // Simulate click to trigger download (prevents memory leaks)
  //     link.style.display = "none";
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     // Resolve with Blob object after simulated click
  //     link.onload = () => {
  //       URL.revokeObjectURL(link.href);
  //       resolve(new Blob([dataURL.substring(22)], { type: "image/png" })); // Remove data:image/png;base64, prefix
  //     };
  //     link.onerror = reject;
  //   });
  // };

  const handleCopy = () => {
    const copyText = document.createElement("input") as HTMLInputElement;
    document.body.appendChild(copyText);
    copyText.value = activeUrl;
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    document.body.removeChild(copyText);
    setActiveSnackBar({
      state: true,
      name: "success",
      message: "Link copied",
    });
  };

  const handleCopyShortLink = () => {
    const copyText = document.createElement("input") as HTMLInputElement;
    document.body.appendChild(copyText);
    copyText.value = activeShortLink;
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    document.body.removeChild(copyText);
    setActiveSnackBar({
      state: true,
      name: "success",
      message: "Link copied",
    });
  };

  const handleCopyCustomDomainShortLink = () => {
    const copyText = document.createElement("input") as HTMLInputElement;
    document.body.appendChild(copyText);
    copyText.value = activeCustomDomainShortLink;
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    document.body.removeChild(copyText);
    setActiveSnackBar({
      state: true,
      name: "success",
      message: "Link copied",
    });
  };

  // Helper: build custom domain URL synchronously — always fresh, no useMemo to avoid stale closure
  const buildCustomDomainUrl = (path?: string): string => {
    if (!user?.user?.customDomain?.isActive || !user?.user?.customDomain?.domain) return "";
    let domain = user.user.customDomain.domain;
    if (!domain.startsWith("http")) domain = "https://" + domain;
    try {
      const urlObj = new URL(domain);
      if (path) urlObj.pathname = path;
      return urlObj.toString();
    } catch {
      return "";
    }
  };

  // Computed fresh every render so shareViaSocial always captures the latest URL
  const activeCustomDomainUrl = buildCustomDomainUrl(user.currentOLink?.path);
  const activeCustomDomainShortLink = buildCustomDomainUrl(user.currentOLink?.shortCode);

  const handleCopyCustomDomainLink = () => {
    const copyText = document.createElement("input") as HTMLInputElement;
    document.body.appendChild(copyText);
    copyText.value = activeCustomDomainUrl;
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    document.body.removeChild(copyText);
    setActiveSnackBar({
      state: true,
      name: "success",
      message: "Link copied",
    });
  };

  // Truncate URL for display: remove https://, trim to maxLen chars with leading "..."
  const truncateUrl = (url: string, maxLen: number = 30): string => {
    if (!url) return "";
    const clean = url.replace("https://", "");
    if (clean.length <= maxLen) return clean;
    return "..." + clean.slice(-(maxLen));
  };

  const handleGetBase64 = (b64: string, index: number) => {
    const [...newBase64] = base64;
    newBase64[index] = b64;
    setBase64(newBase64);
  };

  // Truncate from the start if longer than maxLen, prepend "..."
  const truncateStart = (str: string, maxLen: number = 30): string => {
    if (!str || str.length <= maxLen) return str;
    return "..." + str.slice(str.length - maxLen);
  };

  const theme = useTheme();
  const maxSteps = olinks.length;

  const handleStepChange = (step: number) => {
    setActiveStep(step);
    if (
      user.currentOLink?.olinksNames &&
      user.currentOLink?.olinksNames.length > 0
    ) {
      if (step > 0) {
        let params = "?name=" + user.currentOLink.olinksNames[step - 1].name;
        setActiveUrl(
          process.env.REACT_APP_BACK_URL +
            "/" +
            user.currentOLink?.path +
            params
        );
      } else {
        setActiveUrl(
          process.env.REACT_APP_BACK_URL +
            "/" +
            user.currentOLink?.path
        );
      }
    }
  };

  useEffect(() => {
    setActiveUrl(
      process.env.REACT_APP_BACK_URL + "/" + user.currentOLink?.path
    );
  }, [user.currentOLink]);

  const [activeShortLink, setActiveShortLink] = useState("");
  useEffect(() => {
    setActiveShortLink(
      process.env.REACT_APP_BACK_URL + "/" + user.currentOLink?.shortCode
    );
  }, [user.currentOLink]);

  useEffect(() => {
    setQrCodeData({
      ...user.qrCode,
    });
  }, [user.qrCode]);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={props.open}
      className={`${styles.share} ${styles.customScroll}`}
    >
      <div className={styles.share__wrapper}>
        <DialogTitle className={`${styles.share__title} text-black`}>
          <p className="text-center ff-gilroy fw-700">Share</p>
          {width <= 1200 && (
            <button className={styles.share__close} onClick={handleClose}>
              <img src={cross} alt="Close edit" width={24} height={24} />
            </button>
          )}
        </DialogTitle>

        <DialogContent className={styles.share__content}>
          <div>
            <Box className={styles.carousel}>
              <SwipeableViews
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={activeStep}
                  onChangeIndex={handleStepChange}
                  enableMouseEvents
              >
                {olinks.map((item, index) => {
                  return (
                      <div className={styles.carousel__slide} key={index}>
                        <div
                            className={`${styles.carousel__wrapper} card card--xl`}
                        >
                          <div
                              ref={qrCodeImageRef}
                              className={`${styles.export_block}`}
                          >
                            <div ref={qrCodeRef} className={styles.carousel__code}>
                              <QRCode
                                  data={qrCodeData}
                                  url={(( user.user.customDomain?.isActive && activeCustomDomainUrl )
                                      ? activeCustomDomainUrl : activeUrl)}
                                  componentName={true}
                                  enableUpdate={true}
                                  loaded={(e: boolean) => setLoading(e)}
                                  ref={childComponentRef}
                              />
                            </div>
                            <p className="text-center text-black ff-gilroy fw-600">
                              {item.path}
                            </p>
                          </div>
                        </div>
                      </div>
                  );
                })}
              </SwipeableViews>

              {maxSteps >= 2 ? (
                  <MobileStepper
                      steps={maxSteps}
                      position="static"
                      variant="dots"
                      activeStep={activeStep}
                      className={styles.carousel__pagination}
                      nextButton={
                        <>
                          {width > 767 && (
                              <Button
                                  className={styles.carousel__navArrow}
                                  disabled={activeStep === maxSteps}
                              >
                                {theme.direction === "rtl" ? (
                                    <KeyboardArrowLeft />
                                ) : (
                                    <KeyboardArrowRight />
                                )}
                              </Button>
                          )}
                        </>
                      }
                      backButton={
                        <>
                          {width > 767 && (
                              <Button
                                  className={styles.carousel__navArrow}
                                  disabled={activeStep === 0}
                              >
                                {theme.direction === "rtl" ? (
                                    <KeyboardArrowRight />
                                ) : (
                                    <KeyboardArrowLeft />
                                )}
                              </Button>
                          )}
                        </>
                      }
                  />
              ) : null}
            </Box>

            <div className={`${styles.share__row} mb-25`}>
              <button
                  className={`${styles.share__btn} `}
                  onClick={handleDownload}
                  disabled={loading}
              >
                <img
                    src={loading ? downloadGrey : download}
                    alt="icon"
                    width={24}
                    height={24}
                />
                Download
              </button>

              <button
                  id="copyBtn"
                  className={`${styles.share__btn}`}
                  onClick={() => copyToClipboard()}
                  disabled={loading}
              >
                <img
                    src={loading ? copyGray : copy}
                    alt="icon"
                    width={24}
                    height={24}
                />
                Copy
              </button>
            </div>

            {user?.user?.customDomain && user?.user?.customDomain.isActive ? (
              <>
                <h5 className={`${styles.border_top} text-black ff-gilroy mb-10`}>
                  Default Link
                </h5>

                <div className={`flex-1`}>
                    <h5 className={`text-black ff-gilroy mb-0`}>
                      {truncateStart(activeCustomDomainUrl.replace("https://", ""))}
                    </h5>
                    <h6 className={`text-gray_dark ff-gilroy mb-0 ml-10`}>
                      {truncateStart(activeUrl.replace("https://", ""))}
                    </h6>
                </div>

                <div className={`${styles.share__row} mb-30`}>
                  <button
                      className={styles.share__btn}
                      onClick={shareViaSocial("link", activeCustomDomainUrl)}
                  >
                    <img src={share} alt="icon" width={24} height={24} /> Share
                  </button>
                  <button className={styles.share__btn} onClick={handleCopyCustomDomainLink}>
                    <img src={copy} alt="icon" width={24} height={24} /> Copy
                  </button>
                </div>
              </>
            ) : (
                <>
                  <h5 className={`${styles.border_top} text-black ff-gilroy mb-10`}>
                    Default Link
                  </h5>
                  <p className="text-gray_dark mb-20 text-overflow">{activeUrl}</p>

                  <div className={`${styles.share__row} mb-30`}>
                    <button
                        className={styles.share__btn}
                        onClick={shareViaSocial("link", activeUrl)}
                    >
                      <img src={share} alt="icon" width={24} height={24} /> Share
                    </button>
                    <button className={styles.share__btn} onClick={handleCopy}>
                      <img src={copy} alt="icon" width={24} height={24} /> Copy
                    </button>
                  </div>
                </>
            )}

            {user?.user?.customDomain && user?.user?.customDomain.isActive ? (
              <>
                <h5 className={`${styles.border_top} text-black ff-gilroy mb-10`}>
                  Short Link
                </h5>
                <div className={`flex-1`}>
                  <h5 className={`text-black ff-gilroy mb-0`}>
                    {truncateStart(activeCustomDomainShortLink.replace("https://", ""))}
                  </h5>
                  <h6 className={`text-gray_dark ff-gilroy mb-0 ml-10`}>
                    {truncateStart(activeShortLink.replace("https://", ""))}
                  </h6>
                </div>

                <div className={`${styles.share__row} mb-30`}>
                  <button
                      className={styles.share__btn}
                      onClick={shareViaSocial("link", activeCustomDomainShortLink)}
                  >
                    <img src={share} alt="icon" width={24} height={24} /> Share
                  </button>
                  <button className={styles.share__btn} onClick={handleCopyCustomDomainShortLink}>
                    <img src={copy} alt="icon" width={24} height={24} /> Copy
                  </button>
                </div>
              </>
            ) : (
              <>
                <h5 className={`${styles.border_top} text-black ff-gilroy mb-10`}>
                  Short Link
                </h5>
                <p className="text-gray_dark mb-20 text-overflow">
                  {activeShortLink.replace("https://", "")}
                </p>

                <div className={`${styles.share__row} mb-30`}>
                  <button
                    className={styles.share__btn}
                    onClick={shareViaSocial("link", activeShortLink)}
                  >
                    <img src={share} alt="icon" width={24} height={24} /> Share
                  </button>
                  <button className={styles.share__btn} onClick={handleCopyShortLink}>
                    <img src={copy} alt="icon" width={24} height={24} /> Copy
                  </button>
                </div>
              </>
            )}

            {/*{user?.user?.customDomain && user?.user?.customDomain.isActive ? (*/}
            {/*  <>*/}
            {/*    <h5*/}
            {/*      className={`${styles.border_top} text-black ff-gilroy mb-10`}*/}
            {/*    >*/}
            {/*      Custom Domain Link*/}
            {/*    </h5>*/}
            {/*    <div className={`flex-1`}>*/}
            {/*      <h5 className={`text-black ff-gilroy mb-0`}>*/}
            {/*        {activeCustomDomainUrl.replace("https://", "")}*/}
            {/*      </h5>*/}
            {/*      <h6 className={`text-gray_dark ff-gilroy mb-0 ml-10`}>*/}
            {/*        {activeUrl.replace("https://", "")}*/}
            {/*      </h6>*/}
            {/*    </div>*/}
            {/*    /!*<p className="text-gray_dark mb-20 text-overflow">*!/*/}
            {/*    /!*  { activeCustomDomainUrl }*!/*/}
            {/*    /!*</p>*!/*/}

            {/*    <div className={`${styles.share__row} mb-30`}>*/}
            {/*      <button*/}
            {/*        className={styles.share__btn}*/}
            {/*        onClick={shareViaSocial("link", activeCustomDomainUrl)}*/}
            {/*      >*/}
            {/*        <img src={share} alt="icon" width={24} height={24} /> Share*/}
            {/*      </button>*/}
            {/*      <button*/}
            {/*        className={styles.share__btn}*/}
            {/*        onClick={handleCopyCustomDomainLink}*/}
            {/*      >*/}
            {/*        <img src={copy} alt="icon" width={24} height={24} /> Copy*/}
            {/*      </button>*/}
            {/*    </div>*/}
            {/*  </>*/}
            {/*) : null}*/}

          </div>

        </DialogContent>
      </div>
    </Dialog>
  );
};

export default ShareDialog;
